<style scoped>
  .row{
    border-bottom:1px solid #e9eaec;line-height: 30px;
    padding-bottom:15px;
    padding-top:5px;
  }
</style>
<template>
  <div>

    <Alert banner type="error">
      联系后请填写跟进记录，以免重复联系！
    </Alert>

    <quill-editor :content="detail.content" :options = "editorOption" @change="onEditorChange($event)"></quill-editor>
    <div style="color:orange;line-height: 20px;" v-if="detail.id">提示：当前正在编辑，修改内容后提交即可</div>
    <br/>
    <!--反馈类型：-->
    <!--<RadioGroup v-model="detail.lx">-->
      <!--<Radio label="反馈"></Radio>-->
      <!--<Radio label="计划"></Radio>-->
    <!--</RadioGroup>-->
    <!--<br/>-->
    <!--<br/>-->
    <!--<span v-if="detail.lx==='计划'">-->
       <!--计划提醒时间：-->
      <!--<DateOne v-model="detail.ttime"></DateOne>-->
      <!--<br/>-->
      <!--<br/>-->
    <!--</span>-->
    <Button type="primary" @click="save" :loading="loading">提交反馈</Button>
    <Row style="margin-top:20px" v-for="item in list">
      <Col span="24" class="row">
      {{item.uname}}<span>反馈于：{{item.ctime}}</span>
      &nbsp; &nbsp;
      <span>
         <a @click="edit(item.id,item.content)">编辑</a><cite>|</cite>
          <Poptip
            confirm
            title="确定要删除吗，操作不可恢复"d
            @on-ok="remove(item.id)"
            @on-cancel="cancel">
            <a style="color:#ed4014">删除</a>
          </Poptip>
      </span>
      <br/>
      <span v-html="item.content"></span>
      </Col>
    </Row>

  </div>
</template>

<script>
  /**
   * 富文本编辑器
   */
  import { quillEditor } from 'vue-quill-editor'
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import DateOne from '@/public/date/DateOne'
  export default {
    components:{quillEditor,DateOne},
    props:{
      yid:{
        type:Number,
        default:0
      },
      type:{
        type:String,
        default:''
      },
    },
    data(){
      return{
        temp:{
          //员工维护模板
          user:'现居住地（某市某区）：<br/>所在公司：<br/>任职岗位：<br/>能力评估：<br/>本次联系内容：'
        },

        list:[],
        detail:{
          uid:this.$storage.getSession('uid'),
          content:'',
          lx:'反馈',
        },
        loading:false,
        editorOption:{
          modules:{
            toolbar:[
              ['bold', 'italic', 'underline'],
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'font': [] }],
              [{ 'align': [] }],
              [{ 'indent': '-1'}, { 'indent': '+1' }],// 值-1，+1等
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],// 值ordered，bullet
              ['link'],
            ]
          }
        },
      }
    },
    methods:{
      load(){
        let that = this;
        this.$axios.get('/api/zhiku/cofeedback/load?yid='+this.yid+'&type='+this.type).then(function(rs){
          that.list = rs.data;
        });
      },
      edit(id,content){
        this.detail.content = content;
        this.detail.id = id;
      },
      onEditorChange(obj){
        this.detail.content = obj.html;
      },
      save(){
        if(!this.detail.content){
          this.$Message.error('内容不可为空');
          return;
        }
        if(this.detail.lx === '计划'&&!this.detail.ttime){
          this.$Message.error('请选择计划提醒时间');
          return;
        }
        this.detail.yid = this.yid;
        let that = this;
        this.detail.type=this.type;
        this.detail.uid = this.$storage.getSession('uid');
        let data = Object.assign({}, this.detail);
        this.loading = true;
        this.$axios({url:'/api/zhiku/cofeedback/save',method:'post',data:this.$qs.stringify(data)}).then(function(rs){
          that.toast(rs.data);
          if(rs.data.success){
            that.detail.content = '';
            that.detail.id = 0;
          }
          that.loading = false;
        });
      },
      toast(data){
        if(data.success){
          this.load();
          this.$store.commit('setLoginAction',{val:1});
          this.$Message.success(data.msg);
        }else{
          this.$Message.error(data.msg);
        }
      },
      remove(fbid){
        let that = this;
        this.$axios.get('/api/zhiku/cofeedback/delete?ids='+fbid).then(function(rs){
          that.toast(rs.data);
        });
      }
    },
    created(){
      this.load();
    },
    watch:{
      yid:{
        handler(newValue, oldValue) {
          this.load();
        },
        deep: true
      },
    }

  }
</script>



// WEBPACK FOOTER //
// src/components/common/FeedBack.vue